import { FtblMatchInfo } from './ftblMatchInfo.types';

export const hasFtblMatchScore = (matchInfo: FtblMatchInfo): boolean =>
    matchInfo.HomeTeamScore != null && matchInfo.GuestTeamScore != null;
import { FtblMatchInfo } from './ftblMatchInfo.types';

export const hasFtblMatchScore = (matchInfo: FtblMatchInfo): boolean =>
    matchInfo.HomeTeamScore != null && matchInfo.GuestTeamScore != null;
